<template>
	<div id="walkmesettings">
		<input id="UserName" name="UserName" type="hidden" v-model="userName" />
		<input id="UserEmail" name="UserEmail" type="hidden" v-model="userEmail" />
		<input id="UserRole" name="UserRole" type="hidden" v-model="userRole" />
		<input
			id="ValidPreferences"
			name="ValidPreferences"
			type="hidden"
			v-model="validPreferences"
		/>
	</div>
</template>

<script>
/* NOTE: The userName and userEmail data is also being utilized by App Dynamics */
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'WalkMeLoginSettings',
	computed: mapState({
		userName: (state) => state.profile.email,
		userEmail: (state) => state.profile.email,
		userRole: (state) => (state.profile.roles || []).join(','),
		validPreferences() {
			return this.isValidPreferences()();
		},
	}),
	methods: {
		...mapGetters(['isValidPreferences']),
	},
};
</script>
